import { render, staticRenderFns } from "./EditMenu.vue?vue&type=template&id=a9daa93a&scoped=true"
import script from "./EditMenu.vue?vue&type=script&lang=js"
export * from "./EditMenu.vue?vue&type=script&lang=js"
import style0 from "./EditMenu.vue?vue&type=style&index=0&id=a9daa93a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9daa93a",
  null
  
)

export default component.exports